import { Outlet } from 'react-router-dom';

import { AccountLayout } from '@/features/account';
import { GuardPublicOnly } from '@/features/auth';

export const AccountPublicOnlyLayout: React.FC = () => {
  return (
    <GuardPublicOnly>
      <AccountLayout>
        <Outlet />
      </AccountLayout>
    </GuardPublicOnly>
  );
};
